// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d54f8d7c","147":"48198676","295":"90ccdbdc","362":"bfd2ac93","574":"d0221ff1","807":"8f438bfb","818":"85176d1d","899":"2ca9adfc","900":"815301c4","996":"482fba96"}[chunkId] + ".chunk.js";
};